<template>
    <div>
        <transition name="fade" mode="out-in">
        <div v-if="show">
            <div class="filter-bar">
                <el-form class="demo-form-inline" :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="" class="custom-filter" prop="search">
                        <el-input v-model.trim="tempQuery['search']" @keyup.enter.native="submitSearch" clearable
                            placeholder="模板名称/概述查询" style="width: 200px;"></el-input>
                    </el-form-item>
                    <el-form-item label="" class="custom-filter" prop="plat_id">
                        <el-select v-model="tempQuery['plat_id']" multiple  collapse-tags filterable :placeholder="'媒体'">
                            <el-option :label="option.name" :value="option.id" v-for="option in isAllowedPlatList"
                                :key="option.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" class="custom-filter" prop="user_ids">
                        <el-select v-model="tempQuery['user_ids']" multiple collapse-tags filterable :placeholder="'归属人'">
                            <el-option :label="option.creator" :value="option.uid" v-for="option in filterUserOptions"
                                :key="option.uid"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" class="custom-filter" prop="group_id">
                        <el-select v-model="tempQuery['group_id']" multiple collapse-tags filterable :placeholder="'归属人部门'">
                            <el-option :label="option.name" :value="option.id" v-for="option in filterGroupOptions"
                                :key="option.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" label-width="0">
                        <el-button size="mini" type="primary" :loading="dataLoading" @click="submitSearch"
                            style="width: 75px;">筛选</el-button>
                        <el-button size="mini" @click="resetForm">重置筛选</el-button>
                    </el-form-item>

                </el-form>
            </div>
            <div class="data-list pr10">
                <div class="tool-bar mb10">
                    <!--<el-button v-if="pageFuncNames.includes('daily_task_create_template')" @click="handleClick('create', null, null)" size="mini" type="primary" plain>创建模板</el-button>-->
                    <el-button v-if="pageFuncNames.includes('daily_task_create_template_new')" @click="handleClickNew('create', null, null)" size="mini" type="primary" plain>创建模板</el-button>
                </div>
                <el-table v-loading="dataLoading" :data="dataList" stripe
                    :header-cell-style="{ background: '#e8eaec', color: '#333' }" style="width: 100%">
                    
                    <el-table-column v-for="(field, index) in columns" 
                    :key="field.name + '-' + index" 
                    :prop="field.name"
                    :label="field.label" 
                    :fixed="index == 0 ? 'left' : null" 
                    show-overflow-tooltip 
                    :min-width="field.width ? field.width : 135">
                        <template slot-scope="scope">
                            <span v-if="field.name == 'use_num'" :class="scope.row.use_num>0?'text-color-primary':''">
                                <a @click="toTaskPage(scope.row)">{{ scope.row[field.name] }}</a>
                            </span>
                            <span v-else>{{ scope.row[field.name] || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" prop="action" label="操作" align="center" width="100">
                        <template slot-scope="scope">
                            <div class="text-color-primary">
                                <el-dropdown 
                                    v-if="isHasEditFunc" 
                                    @command="(type) => scope.row.type ==='1'? handleClickNew(type, scope.row, scope.$index): handleClick(type, scope.row, scope.$index)"
                                >
                                    <span class="el-dropdown-link" style="cursor: pointer;">
                                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item 
                                        command="info"
                                        >详情</el-dropdown-item>
                                        <el-dropdown-item
                                        command="edit">编辑</el-dropdown-item>
                                        <el-dropdown-item
                                        command="copy">复制</el-dropdown-item>
                                        <el-dropdown-item
                                        command="pull">推送</el-dropdown-item>
                                        <el-dropdown-item
                                        command="delete">
                                            <span style="color: red;">删除</span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <span v-else>--</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-bar tac mt20">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="tempQuery.pn" :page-sizes="[30, 50, 100]" :page-size="tempQuery.rn" :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCnt">
                </el-pagination>
            </div>
        </div>
        <div v-else>
            <CreateTemp v-if="create_type == 'old'" :type="type" :pull="pull" :allowedPlatList="isAllowedPlatList" @goBack="handleShow" @changeType="handleChangeType"/>
            <CreateTempNew v-if="create_type == 'new'" :type="type" :pull="pull" :allowedPlatList="allowedPlatList" @goBack="handleShow"/>
        </div>
        </transition>
        <el-dialog :visible.sync="dialogVisible" title="推送人选择" width="450px" append-to-body :before-close="handleClose"
            destroy-on-close>
            <div style="min-height: 80px;">
                <el-select v-model="name" multiple filterable remote reserve-keyword placeholder="请输入关键词"
                    :remote-method="remoteMethod" :loading="dialoading" style="width: 100%;">
                    <el-option :label="option.name" :value="option.id" v-for="option in list" :key="option.id"></el-option>
                </el-select>

            </div>
            <div slot="footer" class="dialog-footer tac">
                <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
                <el-button type="primary" @click="handleOk" class="action-btn ml20" :loading="dialogloading">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
import CreateTemp from './create.vue';
import CreateTempNew from './create_new.vue';
import {
    getTemplateList,
    getTemplateSelectUser,
    getTemplateSelecGroup,
    getTemplateUserList,
    postTemplateUserPush,
    postTemplateDel
} from '@/api/efficiencyTool/template.js'
export default {
    name: 'efficiencyTool_temp_list',
    props: ['allowedPlatList','pageFuncNames'],
    components: {
        CreateTemp,
        CreateTempNew
    },
    data() {
        return {
            dialogloading: false, //推送loading
            show: true,
            type: 'create',
            create_type: 'old', // old 旧 new 新
            pull: {},
            dataLoading: false,
            tempQuery: {
                search: '',
                plat_id: [],
                user_ids: [],
                group_id: [],
                pn: 1,
                rn: 30,
            },
            filterUserOptions: [],
            filterGroupOptions: [],
            dataList: [],
            totalCnt: 0,
            columns: [
                {
                    name: 'template_id',
                    label: '模板ID',
                    width: 100
                },
                {
                    name: 'template_name',
                    label: '模板名称',
                    width: 200
                },
                {
                    name: 'desc',
                    label: '模板概述',
                    width: 250
                },
                {
                    name: 'plat_name',
                    label: '媒体',
                    width: 100
                },
                {
                    name: 'use_num',
                    label: '使用任务',
                    width: 120
                },
                {
                    name: 'creator',
                    label: '归属人',
                    width: 120
                },
                {
                    name: 'create_time',
                    label: '创建日期',
                    width: 120
                }
            ],
            dialogVisible: false,
            dialoading: false,
            list: [],  //推送人列表
            name: '', //推送人选中
            pullid: '' // 推送模板id 与 template_id 相同
        }
    },
    computed:{
        ...mapGetters({
            user_id:'user_id',
            user_name:'name',
        }),
        isHasEditFunc(){
            return this.pageFuncNames.includes('daily_task_feature');
        },
        isAllowedPlatList() {
            return this.allowedPlatList;
        }
    },
    mounted() {
        getTemplateSelectUser().then(res => {
            this.filterUserOptions = res.data

            if(!this.filterUserOptions.find(item=>item.uid==this.user_id)){
                this.filterUserOptions.push({
                    uid:this.user_id,
                    creator:this.user_name,
                })
            }
            this.resetUserId();
        },err => {
            this.$message.error(err.info);
        })
        getTemplateSelecGroup().then(res => {
            this.filterGroupOptions = res.data
        },err => {
            this.$message.error(err.info);
        })
        // getTemplateUserList({search:''}).then(res => {
        //     this.dialoading = false;
        //     this.list = res.data
        // },err => {
        //     this.$message.error(err.info);
        // })
        // this.fetchgetList(this.tempQuery)
    },
    methods: {
        handleShow(val) {
            console.log(val)
            this.show = val
            this.$nextTick(()=>{
                this.fetchgetList(this.tempQuery)
            })
        },
        fetchgetList(params) {
            this.dataLoading = true
            return getTemplateList(params).then(res => {
                this.dataLoading = false
                this.dataList = res.data.list
                this.totalCnt = res.data.totalCnt
                this.tempQuery.pn = res.data.pageNum
                this.tempQuery.rn = res.data.pageSize
            },err => {
                this.dataLoading = false
                this.$message.error(err.info);
            })
            
        },
        handleClick(type, items, index) {
            if (type == 'pull') {
                this.pullid = items['template_id']
                this.name  = ''
                this.dialogVisible = true
            } else if(type == 'delete') {
                this.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.handleConfirm(items, index)
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            } else {
                this.type = type
                let res_items = ''
                this.create_type = 'old'
                if(type == 'copy') {
                    res_items = items
                    res_items['template_name'] = `${items['template_name']}-复制`
                }else {
                    res_items = items
                }
                if(type != 'create') {
                    res_items['use_num'] = items['use_num']
                }
                if(type == 'create'&&items){
                    res_items.plat_id = items.plat_id||'';
                }
                this.pull = res_items
                this.show = false
            }
        },
        handleClickNew(type, items, index) {
            if (type == 'pull') {
                this.pullid = items['template_id']
                this.name  = ''
                this.dialogVisible = true
            } else if(type == 'delete') {
                this.$confirm('确定要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.handleConfirm(items, index)
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            } else {
                this.type = type
                let res_items = ''
                this.create_type = 'new'
                if(type == 'copy') {
                    res_items = items
                    res_items['template_name'] = `${items['template_name']}-复制`
                }else {
                    res_items = items
                }
                if(type != 'create') {
                    res_items['use_num'] = items['use_num']
                }
                if(type == 'create'){
                    // res_items.plat_id = items.plat_id||'';
                }
                this.pull = res_items
                this.show = false
            }
        },
        handleChangeType(value) {
            this.type = value
        },
        handleConfirm(items, index) {
            postTemplateDel({ template_id: items['template_id'] }).then(res => {
                this.fetchgetList(this.tempQuery)
                this.$message({
                    type: 'success',
                    message: res.info || '删除成功!'
                });
            },err => {
                this.$message.error(err.info);
            })
        },
        submitSearch() {
            this.fetchgetList(this.tempQuery)
        },
        resetForm() {
            this.resetUserId();
            this.tempQuery.search ='';
            this.tempQuery.plat_id = [];
            // this.tempQuery.user_ids = [];
            this.tempQuery.group_id = [];
            this.tempQuery.pn = 1;
            this.fetchgetList(this.tempQuery)
        },
        handleSizeChange(val) {
            this.tempQuery.rn = val
            this.fetchgetList(this.tempQuery)
        },
        handleCurrentChange(val) {
            this.tempQuery.pn = val
            this.fetchgetList(this.tempQuery)
        },
        // 弹框逻辑
        handleClose() {
            this.dialogVisible = false
        },
        handleOk() {
            this.dialogloading = true
            let res_name = this.name && this.name.join(',')
            if(res_name != '') {
                postTemplateUserPush({user_ids:this.name, template_id:this.pullid}).then(res=>{
                    this.fetchgetList(this.tempQuery)
                    this.dialogloading = false
                    this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message: '推送成功!'
                    });
                },err => {
                    this.dialogloading = false
                    this.$message.error(err.info);
                })
            }else{
                this.dialogloading = false
                this.$message({
                    type: 'info',
                    message: '推送人为空，已取消推送。'
                });
            }
            
        },
        remoteMethod(query) {
            if (query !== '') {
                this.dialoading = true;
                getTemplateUserList({search:query}).then(res => {
                    this.dialoading = false;
                    this.list = res.data
                },err => {
                    this.$message.error(err.info);
                })
            } else {
                this.list = [];
            }
        },
        toTaskPage(data){
            this.$emit('toTaskPage',data);
        },
        searchList(data){
            if(!this.show){
                this.show = true;
            }
            console.log('searchList 111',data);
            // this.resetForm();

            // this.resetUserId();
            this.tempQuery.search =data.templateName?data.templateName:'';
            if (this.isAllowedPlatList.some(v=>v.id === data.platId)) {
                console.log('有权限');
                this.tempQuery.plat_id = [data.platId]
            }else {
                console.log('无权限', this.isAllowedPlatList, data);
                this.tempQuery.plat_id = []
            }
            this.tempQuery.user_ids = data.pageType=='view_template'?[]:[this.user_id];
            this.tempQuery.group_id = [];
            this.tempQuery.pn = 1;
            this.fetchgetList(this.tempQuery).then(()=>{
                if(data.pageType=='view_template'){
                    let templateIndex = this.dataList.findIndex(item=>item.template_name==data.templateName&&item.template_id==data.templateId);
                    let templateItem = this.dataList.find(item=>item.template_name==data.templateName&&item.template_id==data.templateId);
                    if(templateIndex!=-1){
                        // 修改判断方式   同一媒体有新模板数据和旧模板数据 根据type判断跳那个模板
                        if(templateItem.type ==='1'){
                            this.handleClickNew('info',templateItem,templateIndex);
                        }else{
                            this.handleClick('info',templateItem,templateIndex);
                        }
                    }else{
                        this.$message.error('未找到该模板')
                    }
                }
            });
            if(data.toCreatePage){
                if(data.platId !='8'){
                    this.handleClickNew('create', {plat_id:data.platId}, null);
                }else{
                    this.handleClick('create', {plat_id:data.platId}, null);
                }
            }
        },
        resetUserId(){
            let userData = (this.filterUserOptions||[]).find(item=>item.uid==this.user_id&&item.creator==this.user_name);
            if(!userData){
                this.filterUserOptions.push({
                    uid:this.user_id,
                    creator:this.user_name,
                })
            }
            this.tempQuery.user_ids = [this.user_id];
        },
    }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.list-page ::v-deep.el-table .gray-row {
    background-color: #f4f4f4;
}

.ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.create_vivo_list tbody .cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.demo-form-inline {
    padding: 20px 20px 0;
    background: #f8f8f9;
    margin-bottom: 10px;
}
</style>
